import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './components/Home';
import Studio from './components/Studio';

function App() {

  return (
    <Router>
      <div className="min-h-screen p-8">
        <div className="container mx-auto">
          {/* <Header parentCategories={parentCategories} /> */}
          {/* <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} /> */}
          <Routes>
            <Route
              path="/"
              element={
                <Home />
              }
            />
            <Route
              path="/studio/:id"
              element={
                <Studio />
              }
            />

          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;